import Vue from 'vue'
import Router from 'vue-router'
import store from '@/stores/index'
import Login from '@/views/Login';

const ForgotPassword = () => import(/* webpackChunkName: "/static/js/chunks/cl1xx" */'@/views/ForgotPassword');

// CL2xx
const ContactUs = () => import(/* webpackChunkName: "/static/js/chunks/contact" */ '@/views/contact/ContactUs');
const FAQ = () => import(/* webpackChunkName: "/static/js/chunks/contact" */ '@/views/contact/FAQ');
const ContactForm = () => import(/* webpackChunkName: "/static/js/chunks/contact" */ '@/views/contact/ContactForm');
const Notification = () => import(/* webpackChunkName: "/static/js/chunks/" */ '@/views/Notification');
const NotificationDetail = () => import(/* webpackChunkName: "/static/js/chunks/" */ '@/views/NotificationDetail');
const Account = () => import(/* webpackChunkName: "/static/js/chunks/user" */ '@/views/user/Account');
const EmailChanged = () => import(/* webpackChunkName: "/static/js/chunks/user" */ '@/views/user/EmailChanged');
const TermsOfService = () => import(/* webpackChunkName: "/static/js/chunks" */'@/views/TermsOfService');
const TermsOfService202201 = () => import(/* webpackChunkName: "/static/js/chunks" */'@/views/TermsOfService202201');
const SpecifiedCommodityTransactionLaw = () => import(/* webpackChunkName: "/static/js/chunks/transaction-law" */'@/views/SpecifiedCommodityTransactionLaw');
const Privacy = () => import(/* webpackChunkName: "/static/js/chunks/privacy" */'@/views/Privacy');

const ProjectList = () => import(/* webpackChunkName: "/static/js/chunks/project" */'@/views/project/ProjectList');
const UpdateConstructionInfo = () => import(/* webpackChunkName: "/static/js/chunks/project" */'@/views/project/UpdateConstructionInfo');

const ServiceDescription = () => import(/* webpackChunkName: "/static/js/chunks/register" */ '@/views/register/ServiceDescription');
const ServiceDescriptionCloud = () => import(/* webpackChunkName: "/static/js/chunks/register" */ '@/views/register/ServiceDescriptionCloud');
const TempRegister = () => import(/* webpackChunkName: "/static/js/chunks/register" */ '@/views/register/TempRegister');
const FullInfoRegister = () => import(/* webpackChunkName: "/static/js/chunks/register" */ '@/views/register/FullInfoRegister');
const UrlRegisterInvalid = () => import(/* webpackChunkName: "/static/js/chunks/register" */ '@/views/register/UrlRegisterInvalid');
const ResetPassword = () => import(/* webpackChunkName: "/static/js/chunks/cl1xx" */'@/views/ResetPassword');
const CreateReportPosition = () => import(/* webpackChunkName: "/static/js/chunks/report" */'@/views/reports/position/ReportPosition');
const CreateReportLayout = () => import(/* webpackChunkName: "/static/js/chunks/report" */'@/views/reports/CreateReportLayout');
const ReportDetail = () => import(/* webpackChunkName: "/static/js/chunks/report" */'@/views/reports/detail/ReportDetail');
const EditConstructionSite = () => import(/* webpackChunkName: "/static/js/chunks/report" */'@/views/reports/constructionsite/ConstructionSite');
const AcceptInvite = () => import(/* webpackChunkName: "/static/js/chunks/user" */'@/views/user/AcceptInvite');
const AddConstructionUser = () => import(/* webpackChunkName: "/static/js/chunks/user" */'@/views/user/AddConstructionUser');

// terms
const TermsNotification = () => import(/* webpackChunkName: "/static/js/chunks/terms" */'@/views/terms/Notification.vue');
const TermsQA = () => import(/* webpackChunkName: "/static/js/chunks/terms" */'@/views/terms/QA.vue');
const TermsContent = () => import(/* webpackChunkName: "/static/js/chunks/terms" */'@/views/terms/Content.vue');
const TermsPrivacyPolicy = () => import(/* webpackChunkName: "/static/js/chunks/terms" */'@/views/terms/PrivacyPolicy.vue');
const TermsInformation = () => import(/* webpackChunkName: "/static/js/chunks/terms" */'@/views/terms/Information.vue');

const IOSAppDownload = () => import(/* webpackChunkName: "/static/js/chunks/static" */'@/views/static/IOSAppDownload.vue');

const Top = () => import(/* webpackChunkName: "/static/js/chunks/top" */'@/views/CL001_Top.vue');
Vue.use(Router)
// CL6xx
const ConfirmRegisterNewUser = () => import(/* webpackChunkName: "/static/js/chunks/share-construction" */'@/views/share-construction/ConfirmRegisterNewUser.vue')
const FullRegisterNewUser = () => import(/* webpackChunkName: "/static/js/chunks/share-construction" */'@/views/share-construction/FullRegisterNewUser.vue')

const PdfView = () => import(/* webpackChunkName: "/static/js/chunks/pdf-view" */'@/views/PdfView.vue')

const SearchConstruction = () => import(/* webpackChunkName: "/static/js/chunks/constructions" */'@/views/project/SearchConstruction');
// const SearchConstructionSite = () => import(/* webpackChunkName: "/static/js/chunks/constructionsite" */'@/views/project/SearchConstructionSite');

// Softbank and Trail All User
const Softbank = () => import(/* webpackChunkName: "/static/js/chunks/softbank" */'@/views/softbank/Softbank')
const SoftbankConfirmation = () => import(/* webpackChunkName: "/static/js/chunks/softbank" */'@/views/softbank/SoftbankConfirmation')
const SoftbankCompletion = () => import(/* webpackChunkName: "/static/js/chunks/softbank" */'@/views/softbank/SoftbankCompletion')
const AddStampConstructionSite = () => import(/* webpackChunkName: "/static/js/chunks/constructionsite" */'@/views/stamp/AddStampConstructionSite');

// acount
const SupervisorList = () => import(/* webpackChunkName: "/static/js/chunks/account" */'@/views/account/SupervisorList')
const OperatorList = () => import(/* webpackChunkName: "/static/js/chunks/account" */'@/views/account/OperatorList')
const AddAccount = () => import(/* webpackChunkName: "/static/js/chunks/account" */'@/views/account/AddAccount')
// const EditSupervisor = () => import(/* webpackChunkName: "/static/js/chunks/account" */'@/views/account/EditSupervisor')
// const EditOperator = () => import(/* webpackChunkName: "/static/js/chunks/account" */'@/views/account/EditOperator')
const EditAccount = () => import(/* webpackChunkName: "/static/js/chunks/account" */'@/views/account/EditAccount')
// construction
const ManagerConstruction = () => import(/* webpackChunkName: "/static/js/chunks/construction" */'@/views/construction/AccountSupervisor')
const ListConstruction = () => import(/* webpackChunkName: "/static/js/chunks/construction" */'@/views/construction/ListConstruction')
const ListParticipate = () => import(/* webpackChunkName: "/static/js/chunks/construction" */'@/views/construction/ListParticipate')
const AddParticipate = () => import(/* webpackChunkName: "/static/js/chunks/construction" */'@/views/construction/AddParticipate')
const SearchConstructionAccount = () => import(/* webpackChunkName: "/static/js/chunks/construction" */'@/views/construction/SearchConstructionAccount')
const LogConstruction = () => import(/* webpackChunkName: "/static/js/chunks/construction" */'@/views/construction/LogConstruction')
const SearchSupervisorList = () => import(/* webpackChunkName: "/static/js/chunks/account" */'@/views/account/SearchSupervisorList')
const SearchOperatorList = () => import(/* webpackChunkName: "/static/js/chunks/account" */'@/views/account/SearchOperatorList')

const DaikinCoverReport = () => import(/* webpackChunkName: "/static/js/chunks/reports/daikin" */ '@/views/reports/daikin/DaikinCoverReport')

const router = new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiredGuest: true
      }
    },
    { path: '/contact', component: ContactUs, name: 'ContactUs' },
    { path: '/faq', component: FAQ, name: 'FAQ' },
    { path: '/contact_input', component: ContactForm, name: 'ContactForm' },
    {
      path: '/notification',
      name: 'Notification',
      component: Notification
    },
    {
      path: '/notification/:notification_id',
      name: 'NotificationDetail',
      component: NotificationDetail
    },
    {
      path: '/account',
      name: 'Account',
      component: Account,
    },
    {
      path: '/change_mail',
      name: 'EmailChanged',
      component: EmailChanged
    },
    {
      path: '/service-description',
      name: 'ServiceDescription',
      component: ServiceDescription,
      meta: {
        requiredGuest: true
      }
    },
    {
      path: '/service-description-cloud',
      name: 'ServiceDescriptionCloud',
      component: ServiceDescriptionCloud,
      meta: {
        requiredGuest: true
      }
    },
    {
      path: '/temp-register',
      name: 'TempRegister',
      component: TempRegister,
    },
    {
      path: '/full-info-register',
      name: 'FullInfoRegister',
      component: FullInfoRegister
    },
    {
      path: '/url-register-invalid',
      name: 'UrlRegisterInvalid',
      component: UrlRegisterInvalid
    },
    {
      path: '/add-construction-user/:construction_id',
      name: 'AddConstructionUser',
      component: AddConstructionUser
    },
    {
      path: '/add-construction-user',
      name: 'AddConstructionUserFromApp',
      component: AddConstructionUser
    },
    {
      path: '/accept-invite',
      name: 'AcceptInvite',
      component: AcceptInvite
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: ForgotPassword,
      meta: {
        requiredGuest: true
      }
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/terms-of-service',
      name: 'TermsOfService',
      component: TermsOfService
    },
    {
      path: '/202201terms-of-service',
      name: 'TermsOfService202201',
      component: TermsOfService202201
    },
    {
      path: '/terms/notification',
      name: 'TermsNotification',
      component: TermsNotification,
      meta: {
        layout: 'copyright'
      }
    },
    {
      path: '/terms/qa',
      name: 'TermsQA',
      component: TermsQA,
      meta: {
        layout: 'copyright'
      }
    },
    {
      path: '/terms/terms',
      name: 'TermsContent',
      component: TermsContent,
      meta: {
        layout: 'copyright'
      }
    },
    {
      path: '/terms/information',
      name: 'TermsInformation',
      component: TermsInformation,
      meta: {
        layout: 'copyright'
      }
    },
    {
      path: '/terms/privacy-policy',
      name: 'TermsPrivacyPolicy',
      component: TermsPrivacyPolicy,
      meta: {
        layout: 'copyright'
      }
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/specified-commodity-transaction-law',
      name: 'SpecifiedCommodityTransactionLaw',
      component: SpecifiedCommodityTransactionLaw
    },
    {
      path: '/create-report-position/:construction_id',
      name: 'CreateReportPosition',
      component: CreateReportPosition,
      meta: {
        requiredAuth: true
      },
      props: true,
    },
    {
      path: '/create-report-position',
      name: 'CreateReportPositionFromApp',
      component: CreateReportPosition
    },
    {
      path: '/create-report-layout/:construction_id',
      name: 'CreateReportLayout',
      component: CreateReportLayout
    },
    {
      path: '/report-detail/:construction_id',
      name: 'ReportDetail',
      component: ReportDetail
    },
    {
      path: '/report-detail',
      name: 'ReportDetailFromApp',
      component: ReportDetail
    },
    {
      path: '/edit-construction-site/:construction_site_id',
      name: 'EditConstructionSite',
      component: EditConstructionSite
    },
    {
      path: '/projects',
      name: 'ProjectList',
      component: ProjectList,
      meta: {
        requiredAuth: true
      }
    },
    {
      path: '/update-construction-info/:construction_id',
      name: 'UpdateConstructionInfo',
      component: UpdateConstructionInfo,
      meta: {
        requiredAuth: true
      }
    },
    {
      path: '/static/ios_app_download',
      name: 'IOSAppDownload',
      component: IOSAppDownload,
      meta: {
        layout: 'no-header'
      }
    },
    {
      path: '/',
      name: 'TOP',
      component: Top,
      meta: {
        isTop: true
      }
    },
    {
      path: '/accept-invite-new-user',
      name: 'FullRegisterNewUser',
      component: FullRegisterNewUser
    },
    {
      path: '/confirm-register-new-user',
      name: 'ConfirmRegisterNewUser',
      component: ConfirmRegisterNewUser
    },
    {
      path: '/pdf-view',
      name: 'PdfView',
      component: PdfView,
      meta: {
        requiredAuth: false,
        layout: 'no-header'
      },
    },
    {
      path: '/search-construction',
      name: 'SearchConstruction',
      component: SearchConstruction
    },
    // {
    //   path: '/search-constructionsite/:construction_id',
    //   name: 'SearchConstructionSite',
    //   component: SearchConstructionSite
    // },
    {
      path: '/apply/softbank',
      name: 'Softbank',
      component: Softbank,
      meta: {
        isSoftbank: true
      }
    },
    {
      path: '/apply/softbank-confirmation',
      name: 'SoftbankConfirmation',
      component: SoftbankConfirmation,
      meta: {
        isSoftbank: true
      }
    },
    {
      path: '/apply/softbank-completion',
      name: 'SoftbankCompletion',
      component: SoftbankCompletion,
      meta: {
        isSoftbank: true
      }
    },
    // trial user use component softbank
    {
      path: '/apply',
      name: 'ApplyTrialUser',
      component: Softbank,
      meta: {
        isSoftbank: true,
        isApplyUser: true,
      }
    },
    {
      path: '/apply/confirmation',
      name: 'ApplyTrialUserConfirmation',
      component: SoftbankConfirmation,
      meta: {
        isSoftbank: true,
        isApplyUser: true,
      }
    },
    {
      path: '/apply/completion',
      name: 'ApplyTrialUserCompletion',
      component: SoftbankCompletion,
      meta: {
        isSoftbank: true,
        isApplyUser: true,
      }
    },
    {
      path: '/add-stamp-construction-site/:construction_site_id',
      name: 'AddStampConstructionSite',
      component: AddStampConstructionSite
    },
    {
      path: '*',
      redirect: '/projects'
    },
    // account
    {
      path: '/supervisor-list',
      name: 'SupervisorList',
      component: SupervisorList,
      meta: {
        isAccount: true
      }
    },
    {
      path: '/operator-list/:manager_user_id',
      name: 'OperatorList',
      component: OperatorList,
      meta: {
        isAccount: true
      }
    },
    {
      path: '/add-account/:manager_user_id',
      name: 'AddAccount',
      component: AddAccount,
      meta: {
        isAccount: true
      }
    },
    {
      path: '/edit-account/:user_id',
      name: 'EditAccount',
      component: EditAccount,
      meta: {
        isAccount: true
      }
    },
    // construction
    {
      path: '/manager-construction',
      name: 'ManagerConstruction',
      component: ManagerConstruction,
      meta: {
        isAccount: false
      }
    },
    {
      path: '/list-construction/:manager_user_id',
      name: 'ListConstruction',
      component: ListConstruction,
      meta: {
        isAccount: false
      }
    },
    {
      path: '/list-participate/:construction_id',
      name: 'ListParticipate',
      component: ListParticipate,
      meta: {
        isAccount: false
      }
    },
    {
      path: '/add-participate/:construction_id',
      name: 'AddParticipate',
      component: AddParticipate,
      meta: {
        isAccount: false
      }
    },
    {
      path: '/search-construction-account/:manager_user_id',
      name: 'SearchConstructionAccount',
      component: SearchConstructionAccount,
      meta: {
        isAccount: false
      }
    },
    {
      path: '/log-construction/:construction_id',
      name: 'LogConstruction',
      component: LogConstruction,
      meta: {
        isAccount: false
      }
    },
    {
      path: '/search-supervisor-list',
      name: 'SearchSupervisorList',
      component: SearchSupervisorList,
      meta: {
        isAccount: true
      }
    },
    {
      path: '/search-operator-list/:manager_user_id',
      name: 'SearchOperatorList',
      component: SearchOperatorList,
      meta: {
        isAccount: true
      }
    },
    {
      path: '/daikin-cover-report/:construction_id',
      name: 'DaikinCoverReport',
      component: DaikinCoverReport,
    },
  ],
})

const waitForStorageToBeReady = async (to, from, next) => {
  await store.restored
  const authUser = store.state.user_info && store.state.user_info.user_id;
  const ACCOUNT_LEVEL_AUTHORITY = [1, 2]
  if (((to.name !== 'Login' && to.meta.requiredAuth) || to.name === null) && !authUser) {
    next({name: 'Login'})
  } else {
    if ((to.name === null || to.name === 'Login') && authUser) {
      next({name: 'ProjectList'})
    }
    if (to.meta.isAccount) {
      if (ACCOUNT_LEVEL_AUTHORITY.includes(store.state.user_info.account_level)) {
        next()
      } else {
        next({name: 'ProjectList'})
      }
    }
    next()
  }
}
router.beforeEach(waitForStorageToBeReady)

export default router



// WEBPACK FOOTER //
// ./src/router/index.js